namespace Areas.Dialogs.TimeEntryCorrection {
    "use strict";

    let employeeId: number;
    let runQuery: boolean = false;
    let timeEntries: any;

    export class TimeEntryCorrectionDialog extends Areas.BaseDialog {
        timeEntries: any;

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void, parameters: any) {
            super("TimeEntryCorrection", closeHandler, parameters, () => {
                employeeId = parameters.employeeId;
                timeEntries = parameters.timeEntries;
                runQuery = true;
                const correctionForm = $("#CorrectionForm").dxForm("instance");
                let formData = correctionForm.option("formData");
                formData.rechargeRate = "-1";
                correctionForm.option("formData", formData);
         
            })
        }

        protected ok = (e: any) => {
            const correctionForm = $("#CorrectionForm").dxForm("instance");

            const result: any = correctionForm.validate();

            if (result.isValid) {
                const formData = correctionForm.option("formData");
                if (formData.rechargeRate == -1) {
                    formData.rechargeRate = null;
                }
                const data = JSON.stringify({
                    employeeId: employeeId,
                    accountWorkOrderId: formData.accountWorkOrderId,
                    fundingSourceId: formData.fundingSourceId,
                    rechargeRate: formData.rechargeRate,
                    taskCodeLk: formData.taskCodeLk,
                    comment: formData.comment,
                    timeEntries: timeEntries
                });
                const url = "/Dialog/TimeEntryCorrection/Put";
                sendRequest(url, data, "PUT", () => this.close(DialogResult.Ok, null));
            }
       }
    }

    export function canExecuteQuery() {
        return runQuery;
    }

    export function getEmployeeId() {
        return employeeId;
    }
    
    export function jobTemplate(itemData: any, itemIndex: any, itemElement: any) {
        itemElement.append(`<div style="width:300px;"><span class="collookupspan" style="width:300px;">${itemData.workOrderCode} -- ${itemData.accountCode}</span>${itemData.workOrderShortDescription}</div>`);
    }     

    export function fundingSourceTemplate(itemData: any, itemIndex: any, itemElement: any) {
        itemElement.append(`<div style="width:300px;"><span class="collookupspan" style="width:150px;">${itemData.fundingSourceCode}</span>${itemData.fundingSourceName}</div>`);
    }     

    export function taskCodeTemplate(itemData: any, itemIndex: any, itemElement: any) {
        itemElement.append(`<div style="width:300px;"><span class="collookupspan" style="width:150px;">${itemData.taskCodeLk}</span>${itemData.taskCodeDescription}</div>`);
    }     

}